import React from 'react';
import '../styles/legal-page.css'; // Ensure the correct CSS is applied
import { Link } from 'react-router-dom';
import Footer from '../components/Footer'; // Import the Footer component

const ContentModerationPolicy: React.FC = () => {
  return (
    <div className="legal-page-container">
      {/* Clickable Dog Image - redirects to homepage */}
      <div className="centered-image-container">
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/curios-dog.jpeg`}
            alt="Curious Dog"
            className="circle-dog-image" 
          />
        </Link>
      </div>

      <div className="legal-content-container">
        <div className="content">
          <h1>Content Moderation Policy</h1>
          <p>
            Curios.dog is committed to providing a safe and welcoming space for all users. This policy outlines the guidelines and procedures for content moderation on our platform.
          </p>

          <h2 className="legal-section-title">1. Moderation Overview</h2>
          <p>
            Our team reviews content reported by users or flagged automatically by our system. We strive to remove content that violates our community guidelines as quickly as possible.
          </p>

          <h2 className="legal-section-title">2. Prohibited Content</h2>
          <p>We prohibit the following types of content on Curios.dog:</p>
          <ul>
            <li>Hate speech or content that incites violence against individuals or groups.</li>
            <li>Sexually explicit or pornographic material.</li>
            <li>Harassment, bullying, or targeted abuse.</li>
            <li>Content that promotes illegal activities.</li>
            <li>Spam, misleading content, or false information.</li>
          </ul>

          <h2 className="legal-section-title">3. Reporting Violations</h2>
          <p>
            Users can report content that they believe violates our guidelines by using the report feature available on each post. Our moderation team reviews reports and takes appropriate action.
          </p>

          <h2 className="legal-section-title">4. Consequences for Violations</h2>
          <p>
            Users who violate our content moderation policy may face consequences such as content removal, account suspension, or permanent bans depending on the severity and frequency of the violations.
          </p>

          <h2 className="legal-section-title">5. Appeals</h2>
          <p>
            If you believe your content was removed in error, you may submit an appeal to our moderation team. We will review the appeal and provide a response within 7 business days.
          </p>

          <h2 className="legal-section-title">6. Updates to Policy</h2>
          <p>
            We may update this content moderation policy from time to time. Changes will be communicated to users through updates on our platform.
          </p>

        </div>

        <div className="join-waitlist-container">
          <button className="join-waitlist-btn" onClick={() => window.location.href = "/join"}>
            Join The Waiting List
          </button>
        </div>
      </div>

      <Footer /> {/* Add the Footer at the bottom of the page */}
    </div>
  );
};

export default ContentModerationPolicy;
